import { useEasykitTaskDisplay } from './useEasykitTaskDisplay';
import type { OdooTask } from '@/types/odoo';

interface EasykitTaskDragPreviewProps {
  task: OdooTask;
}

/**
 * Static, non-sortable clone rendered inside the DragOverlay while a card is dragged.
 * Mirrors the EasykitTaskCard header so the floating ghost is recognisable, without
 * re-registering useSortable (which would collide on the duplicate id).
 */
export function EasykitTaskDragPreview({ task }: EasykitTaskDragPreviewProps) {
  const { color, pill, primaryLabel, soName, projectName, prefix } = useEasykitTaskDisplay(task);

  return (
    <div
      className={`w-[300px] text-left p-1.5 rounded border-l-3 ${color.border} ${color.bg} shadow-lg cursor-grabbing rotate-2`}
    >
      <div className="flex items-center gap-1">
        {pill && (
          <span className={`shrink-0 text-[9px] font-bold px-1.5 py-0.5 rounded ${pill.cls}`}>{pill.label}</span>
        )}
        {prefix && (
          <span className="shrink-0 text-[10px] font-bold text-amber-800 bg-amber-100 px-1.5 py-0.5 rounded truncate max-w-[40%]">{prefix}</span>
        )}
        <p className={`text-xs font-bold truncate flex-1 ${color.text}`}>
          {primaryLabel}
          {soName && <span className="ml-1 font-normal text-td-muted">· {soName}</span>}
        </p>
      </div>
      {projectName && <p className="text-[10px] text-td-muted truncate">{projectName}</p>}
    </div>
  );
}
